/* ============================================================
   ORIX SINGLE-QTY GUARD v2 — máx. 1 unidad por producto.
   Adaptado al tema (Dawn custom): Buy Now async, normaliza vía
   PUB_SUB_EVENTS.cartUpdate, bloqueo sincrónico en add-to-cart.
   ============================================================ */
(function () {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let cartCache = { items: [] };
  let enforcing = false;

  const getCart = () =>
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());

  const hasVariant = (id) =>
    cartCache.items.some(i => String(i.variant_id) === String(id));

  async function refreshCache() {
    try { cartCache = await getCart(); } catch (e) {}
    return cartCache;
  }

  // ── Red de seguridad: baja cualquier qty > 1 a 1 ──
  async function enforceSingles() {
    if (enforcing) return;
    enforcing = true;
    try {
      const cart = await getCart();
      cartCache = cart;
      const over = cart.items.filter(i => i.quantity > 1);
      let changed = false;
      for (const item of over) {
        const res = await fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 1 }),
        });
        cartCache = await res.json();
        changed = true;
      }
      // Dawn re-renderiza drawer y /cart solos al escuchar esto
      if (changed && window.publish && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ori-single-qty', cartData: cartCache });
      }
    } finally {
      enforcing = false;
    }
  }

  // ── Toast (tokens OrioniX) ──
  function toast(msg) {
    let t = document.getElementById('ori-sq-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'ori-sq-toast';
      t.style.cssText =
        'position:fixed;left:50%;bottom:28px;transform:translateX(-50%);background:#09090b;color:#fff;' +
        'border:1px solid #00ff6a;border-radius:12px;padding:12px 18px;font:700 14px/1.2 Poppins,sans-serif;' +
        'z-index:99999;box-shadow:0 8px 30px rgba(0,0,0,.4);opacity:0;transition:opacity .2s,transform .2s;pointer-events:none';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(() => {
      t.style.opacity = '1';
      t.style.transform = 'translateX(-50%) translateY(-4px)';
    });
    clearTimeout(t._h);
    t._h = setTimeout(() => {
      t.style.opacity = '0';
      t.style.transform = 'translateX(-50%)';
    }, 2200);
  }

  function openDrawer() {
    const d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') { try { d.open(); } catch (e) {} }
  }

  // ── Buy Now async (garantiza máx 1) ──
  async function goBuyNow(variantId) {
    try {
      await refreshCache();
      if (!hasVariant(variantId)) {
        await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });
      }
    } catch (e) {}
    window.location.href = root + 'checkout';
  }

  // ── Intercepta el submit de cualquier form /cart/add ──
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || typeof form.getAttribute !== 'function') return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;

    const idEl = form.querySelector('[name="id"]');
    if (!idEl) return;
    const variantId = idEl.value;

    const returnTo = form.querySelector('[name="return_to"]');
    const isBuyNow = returnTo && (returnTo.value || '').indexOf('checkout') !== -1;

    if (isBuyNow) {
      e.preventDefault();
      e.stopImmediatePropagation();
      goBuyNow(variantId);
      return;
    }

    // Add to cart / quick-add: bloquear si ya está
    if (hasVariant(variantId)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      toast('This item is already in your cart');
      toast('Already added — limit 1 per map');
      toast("You've already got this one");
      openDrawer();
    }
  }, true); // captura: corre antes que product-form.js de Dawn

  // ── Interceptar fetch → refresca caché + normaliza tras cada mutación ──
  const _fetch = window.fetch;
  window.fetch = function (...args) {
    const input = args[0];
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = _fetch.apply(this, args);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(() => setTimeout(enforceSingles, 80)).catch(() => {});
    }
    return p;
  };

  // ── init ──
  function init() {
    refreshCache();
    enforceSingles();
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
        if (e && e.source === 'ori-single-qty') return; // evita reentrada
        refreshCache();
      });
    }
  }
  document.readyState !== 'loading'
    ? init()
    : document.addEventListener('DOMContentLoaded', init);
})();